module.exports = __webpack_public_path__ + "img/Monte_Kope_53.4411f567.jpg";